// @ts-nocheck
/** SHIFT+drag reordering for the canvas action bar. */
import { activeSynergyForSpell, slotOfSpell } from "../data";
import { drawBarIcon } from "../spell-icons";
import { Sound } from "../audio";
import { Game } from "./game-base";

export function applySlotMove(loadout, committed, from, to) {
  const fromSpell = loadout?.[from];
  if (!fromSpell) return null;
  const nextLoadout = { ...loadout };
  const nextCommitted = { ...(committed || {}) };
  const toSpell = nextLoadout[to];
  const fromCommit = nextCommitted[from];
  const toCommit = nextCommitted[to];
  if (!toSpell) {
    nextLoadout[to] = fromSpell;
    if (fromCommit) nextCommitted[to] = true;
    else delete nextCommitted[to];
    delete nextLoadout[from];
    delete nextCommitted[from];
  } else {
    nextLoadout[from] = toSpell;
    nextLoadout[to] = fromSpell;
    if (toCommit) nextCommitted[from] = true;
    else delete nextCommitted[from];
    if (fromCommit) nextCommitted[to] = true;
    else delete nextCommitted[to];
  }
  return { loadout: nextLoadout, committed: nextCommitted };
}

Game.prototype.slotReorderAllowed = function () {
  if (this.spectating || this.matchMode === "allrandom") return false;
  if (!this.actionBarVisible()) return false;
  const p = this.spellBarPlayer();
  return !!(p && p.isHuman);
};

Game.prototype.onSlotDragMouseDown = function (e) {
  if (e.button !== 0 || !e.shiftKey || !this.slotReorderAllowed()) return false;
  const slot = this.spellBarSlotAt(e.clientX, e.clientY);
  if (!slot || !slot.spellId) return false;
  if (this.chargingSlot === slot.slot) return false;
  e.preventDefault();
  this.clearSpellBarTip();
  this.slotDrag = {
    from: slot.slot,
    spellId: slot.spellId,
    x: e.clientX,
    y: e.clientY,
    hover: null,
  };
  this.syncCustomCursor();
  return true;
};

Game.prototype.onSlotDragMouseMove = function (e) {
  if (!this.slotDrag) return;
  this.slotDrag.x = e.clientX;
  this.slotDrag.y = e.clientY;
  const hover = this.spellBarSlotAt(e.clientX, e.clientY);
  this.slotDrag.hover = hover && hover.slot !== this.slotDrag.from ? hover.slot : null;
};

Game.prototype.finishSlotDrag = function (e) {
  const drag = this.slotDrag;
  this.slotDrag = null;
  this.syncCustomCursor();
  if (!drag) return;
  const target = this.spellBarSlotAt(e.clientX, e.clientY);
  const to = target?.slot;
  if (!to || to === drag.from) return;

  const p = this.spellBarPlayer();
  if (!p) return;
  const patch = applySlotMove(p.loadout, p.committed, drag.from, to);
  if (!patch) return;

  p.loadout = patch.loadout;
  p.committed = patch.committed;
  if (this.chargingSlot === drag.from) this.chargingSlot = to;
  if (this.net) this.net.send({ t: "slotmove", from: drag.from, to });
  if (typeof this.refreshShopLoadout === "function") this.refreshShopLoadout();
  Sound.ui();
};

Game.prototype.cancelSlotDrag = function () {
  if (!this.slotDrag) return;
  this.slotDrag = null;
  this.syncCustomCursor();
};

Game.prototype.drawSlotDragOverlay = function () {
  const drag = this.slotDrag;
  if (!drag) return;
  const c = this.ctx;
  const lay = this.spellBarLayout();
  const p = this.spellBarPlayer();
  if (!p) return;

  const slotRect = (slotKey) => {
    if (slotKey === lay.spaceSlot) {
      return { x: lay.spaceX, y: lay.ySpace, w: lay.spaceW, h: lay.size };
    }
    const primary = lay.primarySlots.indexOf(slotKey);
    if (primary >= 0) {
      return {
        x: lay.primaryX + primary * (lay.size + lay.gap),
        y: lay.yTop,
        w: lay.size,
        h: lay.size,
      };
    }
    const secondary = lay.secondarySlots.indexOf(slotKey);
    if (secondary >= 0) {
      return {
        x: lay.secondaryX + secondary * (lay.size + lay.gap),
        y: lay.yBottom,
        w: lay.size,
        h: lay.size,
      };
    }
    return null;
  };

  if (drag.hover) {
    const hr = slotRect(drag.hover);
    if (hr) {
      c.save();
      const pad = lay.size * (2 / 58);
      c.strokeStyle = "rgba(232,184,74,0.9)";
      c.lineWidth = Math.max(1, lay.size * (2.5 / 58));
      this.roundRect(hr.x - pad, hr.y - pad, hr.w + pad * 2, hr.h + pad * 2, lay.size * (12 / 58));
      c.stroke();
      c.restore();
    }
  }

  const syn = activeSynergyForSpell(p.loadout, p.committed, p.passives, drag.spellId);
  const synergyId = syn?.id || "";
  c.save();
  c.globalAlpha = 0.92;
  drawBarIcon(c, drag.x, drag.y, lay.size * (synergyId ? 0.94 : 0.88), drag.spellId, synergyId);
  c.restore();
};

Game.prototype.onLoadout = function (msg) {
  const h = this.human();
  if (!h || this.spectating) return;
  const prevChargedId = this.chargingSlot ? h.loadout[this.chargingSlot] : null;
  if (msg.loadout) h.loadout = msg.loadout;
  if (msg.committed) h.committed = msg.committed;
  if (this.chargingSlot && prevChargedId) {
    const newSlot = slotOfSpell(h.loadout, prevChargedId);
    if (newSlot) this.chargingSlot = newSlot;
  }
  if (typeof this.refreshShopLoadout === "function") this.refreshShopLoadout();
};
